module.exports = __webpack_public_path__ + "5a7c486cc7e7b951f52ba37238670ecf.svg";


//////////////////
// WEBPACK FOOTER
// ./res/images/logo/pt/apple_store.svg
// module id = 847
// module chunks = 0